import { ConfirmInitState } from "./types";

const initialState: ConfirmInitState = {
  isOpen: false,
  title: '',
  content: '',
};

export { initialState };
